import {Icon} from 'components-lib';
import React from 'react';

export function getInstrumentIcon(isGeneralInstrument: boolean, isMasterInstrument: boolean) {
  return isGeneralInstrument ? <Icon.GeneralInstrumentIcon /> : !!isMasterInstrument ? <Icon.MasterTemplateIcon /> : '';
}
